// GENERATED FILE - DO NOT EDIT BY HAND.
//
// Rendered from BUILTIN_CLASSIFIERS in platform-services/lumoz-contracts by
// console/scripts/generate_demo_signal_definitions.py. A hand edit is lost on
// the next regen, and CI fails when this file is stale.
//
// This is the same payload /v2/data/classifiers/definitions returns for a real
// tenant. Demo mode has no API, so the Signals tab reads it from here and
// renders exactly what a real app renders.

/* eslint-disable */
export const BUILTIN_SIGNAL_DEFINITIONS = [
  {
    "category": "builtin",
    "classifier_id": "ce35611b-d00e-514d-90ef-d9cb4adcdff3",
    "classifier_key": "loop_detection",
    "classifier_version": 1,
    "description": "Detects agent stuck in repetitive patterns without making progress",
    "eval_source": "detector",
    "holistic": false,
    "is_deleted": false,
    "latest_version": 1,
    "match_type": "detector",
    "name": "Loops",
    "polarity": "negative",
    "scope": "Trace",
    "status": "active",
    "subtype_source_field": "primary_subtype",
    "subtypes": [
      {
        "default_severity": "medium",
        "description": "Same tool called 3+ times with identical arguments and <30% output variation.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [],
        "key": "exact_tool_call_loop",
        "name": "Exact Tool Call Loop"
      },
      {
        "default_severity": "medium",
        "description": "Periodic LLM/TOOL cycle (period 2-6) repeating 3+ times without progress.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [],
        "key": "reason_act_thrash",
        "name": "Reason-Act Thrash"
      },
      {
        "default_severity": "medium",
        "description": "3+ plan/replan steps converging on the same plan content.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [],
        "key": "plan_replan_loop_partial",
        "name": "Plan-Replan Loop"
      },
      {
        "default_severity": "medium",
        "description": "3+ reflection/critique steps converging on 2 or fewer distinct outcomes.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [],
        "key": "reflection_loop_partial",
        "name": "Reflection Loop"
      },
      {
        "default_severity": "medium",
        "description": "Period-2 agent handoff cycle repeating 3+ times.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [],
        "key": "multi_agent_handoff_loop",
        "name": "Multi-Agent Handoff Loop"
      },
      {
        "default_severity": "medium",
        "description": "4+ failed tool calls with identical arguments within a 5-second window.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [],
        "key": "retry_storm_loop",
        "name": "Retry Storm Loop"
      },
      {
        "default_severity": "medium",
        "description": "Periodic cycle (period 2-8) in observed states repeating 3+ times without progress.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [],
        "key": "state_route_loop",
        "name": "State-Route Loop"
      }
    ],
    "tags": [
      "agentic"
    ]
  },
  {
    "category": "builtin",
    "classifier_id": "66b3ac66-b714-5bc6-a549-de5524503525",
    "classifier_key": "error_detection",
    "classifier_version": 1,
    "description": "Detects runtime failures, tool errors, HTTP errors, authentication issues, and configuration problems",
    "eval_source": "detector",
    "holistic": false,
    "is_deleted": false,
    "latest_version": 1,
    "match_type": "detector",
    "name": "Errors",
    "polarity": "negative",
    "scope": "Trace",
    "status": "active",
    "subtype_source_field": "primary_subtype",
    "subtypes": [
      {
        "default_severity": "medium",
        "description": "Span carries a 4xx/5xx HTTP status code.",
        "dynamic": false,
        "event_key_patterns": [
          {
            "default_severity": "medium",
            "description_template": "HTTP {suffix} response status.",
            "dynamic": true,
            "key_prefix": "http_",
            "name_template": "{suffix}"
          }
        ],
        "event_keys": [
          {
            "default_severity": "medium",
            "description": "HTTP status was invalid, out of range, or otherwise not a standard 4xx/5xx code.",
            "key": "http_other",
            "name": "Other Status"
          }
        ],
        "key": "http_error",
        "name": "HTTP"
      },
      {
        "default_severity": "medium",
        "description": "Authentication/authorization failure phrase or provider auth error code matched.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [
          {
            "default_severity": "medium",
            "description": "A credential or token was revoked.",
            "key": "auth_token_revoked",
            "name": "Token Revoked"
          },
          {
            "default_severity": "medium",
            "description": "Authentication failed because credentials were invalid.",
            "key": "auth_invalid_credentials",
            "name": "Invalid Credentials"
          },
          {
            "default_severity": "medium",
            "description": "Authentication failed because required credentials were missing.",
            "key": "auth_credentials_missing",
            "name": "Missing Credentials"
          },
          {
            "default_severity": "medium",
            "description": "Request was not authenticated.",
            "key": "auth_unauthenticated",
            "name": "Unauthenticated"
          },
          {
            "default_severity": "medium",
            "description": "Request lacked permission for the attempted action.",
            "key": "auth_permission_denied",
            "name": "Permission Denied"
          },
          {
            "default_severity": "medium",
            "description": "Request was rejected as unauthorized.",
            "key": "auth_unauthorized",
            "name": "Unauthorized"
          },
          {
            "default_severity": "medium",
            "description": "Request was forbidden by the upstream service.",
            "key": "auth_forbidden",
            "name": "Forbidden"
          },
          {
            "default_severity": "medium",
            "description": "Provider returned an authentication-related HTTP 401 status.",
            "key": "provider_401",
            "name": "Provider 401"
          },
          {
            "default_severity": "medium",
            "description": "Provider returned an authorization-related HTTP 403 status.",
            "key": "provider_403",
            "name": "Provider 403"
          },
          {
            "default_severity": "medium",
            "description": "Provider returned an unauthenticated status code.",
            "key": "provider_unauthenticated",
            "name": "Provider Unauthenticated"
          },
          {
            "default_severity": "medium",
            "description": "Provider returned a permission-denied status code.",
            "key": "provider_permission_denied",
            "name": "Provider Permission Denied"
          }
        ],
        "key": "auth_error",
        "name": "Authentication"
      },
      {
        "default_severity": "medium",
        "description": "AI-provider availability/quota error code or phrase matched.",
        "dynamic": false,
        "event_key_patterns": [
          {
            "default_severity": "medium",
            "description_template": "Provider returned status/code {suffix}.",
            "dynamic": true,
            "key_prefix": "provider_",
            "name_template": "{suffix}"
          }
        ],
        "event_keys": [
          {
            "default_severity": "medium",
            "description": "Provider returned rate-limit HTTP 429.",
            "key": "provider_429",
            "name": "HTTP 429"
          },
          {
            "default_severity": "medium",
            "description": "Provider returned bad gateway HTTP 502.",
            "key": "provider_502",
            "name": "HTTP 502"
          },
          {
            "default_severity": "medium",
            "description": "Provider returned unavailable HTTP 503.",
            "key": "provider_503",
            "name": "HTTP 503"
          },
          {
            "default_severity": "medium",
            "description": "Provider returned gateway timeout HTTP 504.",
            "key": "provider_504",
            "name": "HTTP 504"
          },
          {
            "default_severity": "medium",
            "description": "Provider reported an error without a usable error payload.",
            "key": "provider_empty_error_payload",
            "name": "Empty Error Payload"
          },
          {
            "default_severity": "medium",
            "description": "Provider quota, resource, or rate limit was exhausted.",
            "key": "provider_resource_exhausted",
            "name": "Resource Exhausted"
          },
          {
            "default_severity": "medium",
            "description": "Provider was capacity constrained by high demand.",
            "key": "provider_high_demand",
            "name": "High Demand"
          },
          {
            "default_severity": "medium",
            "description": "Provider reported temporary unavailability.",
            "key": "provider_unavailable",
            "name": "Unavailable"
          },
          {
            "default_severity": "medium",
            "description": "Provider deadline was exceeded.",
            "key": "provider_deadline_exceeded",
            "name": "Deadline Exceeded"
          }
        ],
        "key": "provider_error",
        "name": "Provider"
      },
      {
        "default_severity": "medium",
        "description": "Provider/model safety-policy refusal phrase matched.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [
          {
            "default_severity": "medium",
            "description": "Provider or model refused the request because of safety policy.",
            "key": "policy_safety_refusal",
            "name": "Safety Refusal"
          }
        ],
        "key": "policy_error",
        "name": "Policy"
      },
      {
        "default_severity": "medium",
        "description": "Timeout/deadline-exceeded phrase matched.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [
          {
            "default_severity": "medium",
            "description": "A request or provider operation exceeded its deadline.",
            "key": "timeout_deadline_exceeded",
            "name": "Deadline Exceeded"
          },
          {
            "default_severity": "medium",
            "description": "A request timed out before completion.",
            "key": "timeout_request",
            "name": "Request Timed Out"
          }
        ],
        "key": "timeout_error",
        "name": "Timeout"
      },
      {
        "default_severity": "medium",
        "description": "Configuration/dependency-lookup failure phrase matched (tool/model/agent not found, misconfigured).",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [
          {
            "default_severity": "medium",
            "description": "Required setup or migrations were missing.",
            "key": "config_migration_missing",
            "name": "Migration Missing"
          },
          {
            "default_severity": "medium",
            "description": "Referenced tool could not be found.",
            "key": "config_tool_not_found",
            "name": "Tool Not Found"
          },
          {
            "default_severity": "medium",
            "description": "Referenced agent could not be found.",
            "key": "config_agent_not_found",
            "name": "Agent Not Found"
          },
          {
            "default_severity": "medium",
            "description": "A required dependency or setting was misconfigured.",
            "key": "config_misconfigured",
            "name": "Misconfigured"
          },
          {
            "default_severity": "medium",
            "description": "Configured executable could not be found.",
            "key": "config_executable_missing",
            "name": "Executable Missing"
          },
          {
            "default_severity": "medium",
            "description": "Configured dependency service was unavailable.",
            "key": "config_service_unavailable",
            "name": "Service Unavailable"
          },
          {
            "default_severity": "medium",
            "description": "Referenced model could not be found.",
            "key": "config_model_not_found",
            "name": "Model Not Found"
          }
        ],
        "key": "config_error",
        "name": "Configuration"
      },
      {
        "default_severity": "medium",
        "description": "Database schema error phrase matched (column/table/relation missing).",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [
          {
            "default_severity": "medium",
            "description": "Database query referenced a missing column.",
            "key": "db_column_missing",
            "name": "Column Missing"
          },
          {
            "default_severity": "medium",
            "description": "Database query referenced a missing table or relation.",
            "key": "db_table_missing",
            "name": "Table Missing"
          }
        ],
        "key": "db_schema_error",
        "name": "Database"
      },
      {
        "default_severity": "medium",
        "description": "TOOL span reports an execution error with no more specific matched category.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [
          {
            "default_severity": "medium",
            "description": "Tool invocation reported an execution error.",
            "key": "tool_execution_error",
            "name": "Execution Failed"
          }
        ],
        "key": "tool_execution_error",
        "name": "Tool Execution"
      },
      {
        "default_severity": "high",
        "description": "TOOL span output text contains a high-confidence error keyword.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [
          {
            "default_severity": "high",
            "description": "Tool output reported a connection failure.",
            "key": "tool_connection_error",
            "name": "Connection Failed"
          },
          {
            "default_severity": "high",
            "description": "Tool output reported unavailable service or dependency.",
            "key": "tool_unavailable",
            "name": "Unavailable"
          },
          {
            "default_severity": "high",
            "description": "Tool output reported unauthorized access.",
            "key": "tool_unauthorized",
            "name": "Unauthorized"
          },
          {
            "default_severity": "high",
            "description": "Tool output reported forbidden access.",
            "key": "tool_forbidden",
            "name": "Forbidden"
          },
          {
            "default_severity": "medium",
            "description": "Tool output reported rate limiting.",
            "key": "tool_rate_limited",
            "name": "Rate Limited"
          },
          {
            "default_severity": "medium",
            "description": "Tool output reported a timeout.",
            "key": "tool_timeout",
            "name": "Timed Out"
          },
          {
            "default_severity": "high",
            "description": "Tool output contained high-confidence error text.",
            "key": "tool_error_output",
            "name": "Error Output"
          }
        ],
        "key": "tool_error_output",
        "name": "Tool Output"
      },
      {
        "default_severity": "medium",
        "description": "LLM emitted a tool call with malformed arguments (missing/invalid JSON/non-object).",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [
          {
            "default_severity": "medium",
            "description": "Tool call omitted required arguments.",
            "key": "tool_args_missing",
            "name": "Missing Arguments"
          },
          {
            "default_severity": "medium",
            "description": "Tool-call arguments were not a JSON object.",
            "key": "tool_args_not_object",
            "name": "Arguments Not Object"
          },
          {
            "default_severity": "medium",
            "description": "Tool-call arguments could not be parsed as valid JSON.",
            "key": "tool_args_invalid_json",
            "name": "Invalid JSON"
          }
        ],
        "key": "tool_parameter_error",
        "name": "Tool Parameter"
      },
      {
        "default_severity": "medium",
        "description": "Tool-call arguments don't match the emitted tool schema.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [
          {
            "default_severity": "medium",
            "description": "Tool-call arguments omitted a required schema field.",
            "key": "tool_schema_missing_required",
            "name": "Missing Required Field"
          },
          {
            "default_severity": "medium",
            "description": "Tool-call arguments included a field not declared by the schema.",
            "key": "tool_schema_unknown_parameter",
            "name": "Unknown Parameter"
          },
          {
            "default_severity": "medium",
            "description": "Tool-call argument type did not match the schema.",
            "key": "tool_schema_type_mismatch",
            "name": "Type Mismatch"
          }
        ],
        "key": "tool_schema_error",
        "name": "Tool Schema"
      },
      {
        "default_severity": "medium",
        "description": "LLM called a tool with no matching schema emitted, so arguments can't be validated.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [
          {
            "default_severity": "medium",
            "description": "No emitted schema matched the tool call.",
            "key": "tool_schema_not_found",
            "name": "Schema Not Found"
          }
        ],
        "key": "tool_schema_missing",
        "name": "Missing Tool Schema"
      },
      {
        "default_severity": "medium",
        "description": "TOOL span output is empty or meaningless.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [
          {
            "default_severity": "medium",
            "description": "Tool returned empty or meaningless output.",
            "key": "tool_empty_output",
            "name": "Empty Output"
          }
        ],
        "key": "tool_empty_output",
        "name": "Empty Tool Output"
      },
      {
        "default_severity": "medium",
        "description": "Span carries a bounded or unbounded runtime exception type.",
        "dynamic": false,
        "event_key_patterns": [
          {
            "default_severity": "medium",
            "description_template": "Runtime raised a {suffix} exception.",
            "dynamic": true,
            "key_prefix": "exception_",
            "name_template": "{suffix}"
          }
        ],
        "event_keys": [
          {
            "default_severity": "medium",
            "description": "Span reported an exception type that could not be safely bounded.",
            "key": "exception_other",
            "name": "Other Exception"
          }
        ],
        "key": "exception_error",
        "name": "Exception"
      },
      {
        "default_severity": "medium",
        "description": "Span has an error signal that doesn't match any more specific category.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [
          {
            "default_severity": "medium",
            "description": "Span was marked as errored but no more specific type matched.",
            "key": "span_error",
            "name": "Generic Error"
          }
        ],
        "key": "span_error",
        "name": "Span"
      }
    ],
    "tags": [
      "operational"
    ]
  },
  {
    "category": "builtin",
    "classifier_id": "c4a3da20-cc2a-59ee-9ed6-e1dcfa8304fc",
    "classifier_key": "prompt_injection",
    "classifier_version": 1,
    "description": "Detects attempts to manipulate instructions or override intended agent behavior, in User input and in untrusted content returned by Tool and Retriever spans",
    "eval_source": "detector",
    "holistic": false,
    "is_deleted": false,
    "latest_version": 1,
    "match_type": "detector",
    "name": "Prompt Injection",
    "polarity": "negative",
    "scope": "Tool and Retriever output, User input",
    "status": "active",
    "subtype_source_field": "primary_subtype",
    "subtypes": [
      {
        "default_severity": "high",
        "description": "Injection evidence is not attributed to an indirect/retrieved-content source.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [],
        "key": "direct_prompt_injection",
        "name": "Direct Prompt Injection"
      },
      {
        "default_severity": "high",
        "description": "At least one evidence span is attributed to an indirect source (e.g. retrieved/tool content).",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [],
        "key": "indirect_prompt_injection",
        "name": "Indirect Prompt Injection"
      }
    ],
    "tags": [
      "safety"
    ]
  },
  {
    "category": "builtin",
    "classifier_id": "9ac48b6f-38ed-5603-b1be-c75ab53a705d",
    "classifier_key": "data_exfiltration",
    "classifier_version": 1,
    "description": "Detects sensitive identifiers \u2014 financial account numbers and national ID numbers \u2014 exposed in Tool, Retriever, and LLM output",
    "eval_source": "detector",
    "holistic": false,
    "is_deleted": false,
    "latest_version": 1,
    "match_type": "detector",
    "name": "Data Exfiltration",
    "polarity": "negative",
    "scope": "Tool, Retriever, and LLM output",
    "status": "active",
    "subtype_source_field": "primary_event_key",
    "subtypes": [
      {
        "default_severity": "critical",
        "description": "Luhn-valid card number (13-19 digits) with issuer prefix and non-masked context.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [],
        "key": "credit_card",
        "name": "Credit Card"
      },
      {
        "default_severity": "critical",
        "description": "International Bank Account Number.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [],
        "key": "iban_code",
        "name": "IBAN Code"
      },
      {
        "default_severity": "critical",
        "description": "US bank account number pattern.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [],
        "key": "us_bank_number",
        "name": "US Bank Account Number"
      },
      {
        "default_severity": "critical",
        "description": "US Individual Taxpayer Identification Number, excluding medical-record-number context.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [],
        "key": "us_itin",
        "name": "US ITIN"
      },
      {
        "default_severity": "critical",
        "description": "9-digit US Social Security Number, excluding medical-record-number context.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [],
        "key": "us_ssn",
        "name": "US SSN"
      },
      {
        "default_severity": "high",
        "description": "Cryptocurrency wallet address pattern.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [],
        "key": "crypto",
        "name": "Cryptocurrency Address"
      },
      {
        "default_severity": "high",
        "description": "US driver's license number pattern.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [],
        "key": "us_driver_license",
        "name": "US Driver's License"
      },
      {
        "default_severity": "high",
        "description": "US passport number pattern.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [],
        "key": "us_passport",
        "name": "US Passport Number"
      },
      {
        "default_severity": "high",
        "description": "Indian Goods and Services Tax Identification Number.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [],
        "key": "in_gstin",
        "name": "India GSTIN"
      },
      {
        "default_severity": "high",
        "description": "Indian Permanent Account Number.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [],
        "key": "in_pan",
        "name": "India PAN"
      },
      {
        "default_severity": "high",
        "description": "Indian passport number pattern.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [],
        "key": "in_passport",
        "name": "India Passport Number"
      }
    ],
    "tags": [
      "safety"
    ]
  },
  {
    "category": "builtin",
    "classifier_id": "e7f01b1f-6ac8-57e8-a9db-01e40275ffa4",
    "classifier_key": "workflow_anomaly",
    "classifier_version": 1,
    "description": "Detects departure of a business task, across multiple dimensions, from how that task normally runs",
    "eval_source": "detector",
    "holistic": true,
    "is_deleted": false,
    "latest_version": 1,
    "match_type": "detector",
    "name": "Business Task Anomaly",
    "polarity": "negative",
    "scope": "Trace",
    "status": "active",
    "subtype_source_field": "primary_subtype",
    "subtypes": [
      {
        "default_severity": "medium",
        "description": "The run departs from the task's normal runs across: how heavy and costly it was, and whether it took the usual mix of steps.",
        "dynamic": true,
        "event_key_patterns": [],
        "event_keys": [
          {
            "default_severity": "medium",
            "description": "Trace execution shape was an outlier versus recent workflow history.",
            "key": "structural_outlier",
            "name": "Structural Outlier"
          }
        ],
        "key": "workflow_anomaly",
        "name": "Workload and Execution"
      }
    ],
    "tags": [
      "anomaly"
    ]
  },
  {
    "category": "builtin",
    "classifier_id": "c4229c36-6db9-51ae-b8fe-c22174151d44",
    "classifier_key": "hallucination",
    "classifier_version": 1,
    "description": "Detects claims in the model's response that nothing in its input supports \u2014 the user's message, the system prompt, retrieved documents, and tool results are all checked. Measures grounding in what the model was given, not factual accuracy against the world",
    "eval_source": "detector",
    "holistic": false,
    "is_deleted": false,
    "latest_version": 1,
    "match_type": "detector",
    "name": "Groundedness",
    "polarity": "negative",
    "scope": "Trace",
    "status": "active",
    "subtype_source_field": "primary_subtype",
    "subtypes": [
      {
        "default_severity": "medium",
        "description": "One or more claims in the response are not supported by anything the model was given: not the user's message, the system prompt, retrieved documents, or tool results. This checks the response against its input, not against world knowledge \u2014 a claim can be true and still be flagged if nothing in the input supports it. Deliberately conservative: when support cannot be confidently ruled out, the trace is treated as clean rather than flagged, which keeps false positives low.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [],
        "key": "unsupported_by_full_input",
        "name": "Unsupported Claim"
      }
    ],
    "tags": [
      "quality"
    ]
  },
  {
    "category": "builtin",
    "classifier_id": "815bb774-1790-5819-b564-21d459bde5ca",
    "classifier_key": "tool_correctness",
    "classifier_version": 1,
    "description": "Detects failures where the assistant fabricated tool use, selected the wrong tool, used incorrect parameters, or treated successful tool calls as valid when their payload was unusable",
    "eval_source": "detector",
    "holistic": true,
    "is_deleted": false,
    "latest_version": 1,
    "match_type": "detector",
    "name": "Tool Correctness",
    "polarity": "negative",
    "scope": "Trace",
    "status": "active",
    "subtype_source_field": "primary_subtype",
    "subtypes": [
      {
        "default_severity": "high",
        "description": "Assistant claims a tool was called, or reports a tool observation, without matching execution evidence.",
        "dynamic": false,
        "event_key_patterns": [
          {
            "default_severity": "high",
            "description_template": "Fabricated tool-use claim involving {suffix}.",
            "dynamic": true,
            "key_prefix": "tool_hallucination:",
            "name_template": "{suffix}"
          }
        ],
        "event_keys": [],
        "key": "tool_hallucination",
        "name": "Tool Hallucination"
      },
      {
        "default_severity": "high",
        "description": "Tool returned technical success but an empty, malformed, or wrong payload was treated as successful evidence.",
        "dynamic": false,
        "event_key_patterns": [
          {
            "default_severity": "high",
            "description_template": "Successful tool result was semantically unusable for {suffix}.",
            "dynamic": true,
            "key_prefix": "tool_success_semantic_failure:",
            "name_template": "{suffix}"
          }
        ],
        "event_keys": [],
        "key": "tool_success_semantic_failure",
        "name": "Tool Success Semantic Failure"
      },
      {
        "default_severity": "high",
        "description": "Tool call used arguments that conflict with visible user request, instructions, or prior context.",
        "dynamic": false,
        "event_key_patterns": [
          {
            "default_severity": "high",
            "description_template": "Tool parameter issue involving {suffix}.",
            "dynamic": true,
            "key_prefix": "tool_parameter_error:",
            "name_template": "{suffix}"
          }
        ],
        "event_keys": [],
        "key": "tool_parameter_error",
        "name": "Tool Parameter Error"
      },
      {
        "default_severity": "medium",
        "description": "Assistant selected a visibly inappropriate tool when another available tool matched the requested action.",
        "dynamic": false,
        "event_key_patterns": [
          {
            "default_severity": "medium",
            "description_template": "Wrong tool selection involving {suffix}.",
            "dynamic": true,
            "key_prefix": "wrong_tool_selected:",
            "name_template": "{suffix}"
          }
        ],
        "event_keys": [],
        "key": "wrong_tool_selected",
        "name": "Wrong Tool Selected"
      }
    ],
    "tags": [
      "agentic",
      "quality"
    ]
  },
  {
    "category": "builtin",
    "classifier_id": "cce82244-7e6f-5248-b988-c69baa750fe8",
    "classifier_key": "rag_quality",
    "classifier_version": 1,
    "description": "Detects RAG failures where retrieved context is irrelevant, incomplete, poorly ranked, insufficient, noisy, underused, or unable to support the generated answer",
    "eval_source": "detector",
    "holistic": false,
    "is_deleted": false,
    "latest_version": 1,
    "match_type": "detector",
    "name": "RAG Quality",
    "polarity": "negative",
    "scope": "Trace",
    "status": "active",
    "subtype_source_field": "primary_subtype",
    "subtypes": [
      {
        "default_severity": "medium",
        "description": "Retrieved context is on-topic but does not contain enough information to answer directly.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [],
        "key": "answer_insufficiency",
        "name": "Answer Insufficiency"
      },
      {
        "default_severity": "medium",
        "description": "The answer made claims or conclusions not supported by the retrieved context.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [],
        "key": "unsupported_generation",
        "name": "Unsupported Generation"
      },
      {
        "default_severity": "medium",
        "description": "The answer omitted or underused important retrieved context needed for the query.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [],
        "key": "context_underutilization",
        "name": "Context Underutilization"
      },
      {
        "default_severity": "medium",
        "description": "Retriever returned context for only part of a multi-part or comparison query.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [],
        "key": "incomplete_retrieval",
        "name": "Incomplete Retrieval"
      },
      {
        "default_severity": "medium",
        "description": "Retriever returned context that is materially unrelated to the user query.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [],
        "key": "irrelevant_retrieval",
        "name": "Irrelevant Retrieval"
      },
      {
        "default_severity": "medium",
        "description": "Retriever returned useful context mixed with substantial unrelated or distracting context.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [],
        "key": "noisy_retrieval",
        "name": "Noisy Retrieval"
      },
      {
        "default_severity": "medium",
        "description": "Retriever returned relevant context behind earlier irrelevant or conflicting context.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [],
        "key": "poor_retrieval_ranking",
        "name": "Poor Retrieval Ranking"
      }
    ],
    "tags": [
      "quality",
      "rag"
    ]
  },
  {
    "category": "builtin",
    "classifier_id": "27204c4c-d6d3-5719-80ba-cdb903934bbc",
    "classifier_key": "emotion",
    "classifier_version": 1,
    "description": "Detects user-facing emotional signals such as frustration in conversation traces",
    "eval_source": "detector",
    "holistic": false,
    "is_deleted": false,
    "latest_version": 1,
    "match_type": "detector",
    "name": "Emotion",
    "polarity": "negative",
    "scope": "Trace",
    "status": "active",
    "subtype_source_field": "primary_subtype",
    "subtypes": [
      {
        "default_severity": "medium",
        "description": "User-authored message expresses frustration, anger, disgust, or guarded angry surprise toward the agent experience.",
        "dynamic": false,
        "event_key_patterns": [],
        "event_keys": [
          {
            "default_severity": "medium",
            "description": "User message has high anger probability.",
            "key": "user_frustration:anger",
            "name": "Anger"
          },
          {
            "default_severity": "medium",
            "description": "User message has high disgust probability.",
            "key": "user_frustration:disgust",
            "name": "Disgust"
          },
          {
            "default_severity": "medium",
            "description": "User message has surprise phrasing with anger/disgust co-signal and low joy.",
            "key": "user_frustration:angry_surprise",
            "name": "Angry Surprise"
          }
        ],
        "key": "user_frustration",
        "name": "User Frustration"
      }
    ],
    "tags": [
      "quality",
      "conversation"
    ]
  }
];
